import React, { useState } from 'react';
import { TooltipProvider } from '../components/ui/tooltip';
import { ShowcaseContent } from './BrandShowcase';
import { Palette, FileBarChart, Check } from 'lucide-react';

const BrandShowcaseWhitelabel = () => {
  const [switchOn, setSwitchOn] = useState(true);
  const [checkboxChecked, setCheckboxChecked] = useState(true);
  const [tabValue, setTabValue] = useState('overview');
  const [progressValue] = useState(67);
  const [selectValue, setSelectValue] = useState(null);
  const [dateValue, setDateValue] = useState(null);

  return (
    <TooltipProvider>
      <div className='min-h-screen bg-background'>
        {/* WL Hero: theme-only, no CYF wordmark */}
        <div className='relative overflow-hidden bg-primary'>
          <div className='absolute -top-20 -right-20 w-[400px] h-[400px] rounded-full bg-primary/20' />
          <div className='absolute -bottom-16 left-[300px] w-[280px] h-[280px] rounded-full bg-accent/10' />
          <div className='relative z-10 px-16 py-16 max-w-6xl'>
            <div className='font-mono text-[11px] tracking-[0.18em] uppercase text-primary-foreground/80 mb-3'>
              Theme preview
            </div>
            <h1 className='font-display text-5xl text-primary-foreground leading-tight mb-4'>
              Your brand preview
            </h1>
            <p className='text-base text-primary-foreground/70 max-w-lg leading-relaxed'>
              Full component showcase using your theme. Every element below uses the live theme variables.
            </p>
            <div className='flex gap-4 mt-8 flex-wrap'>
              <span className='flex items-center gap-2 bg-primary-foreground/10 border border-primary-foreground/20 px-4 py-1.5 rounded-full text-xs text-primary-foreground/90'>
                <Palette size={14} strokeWidth={1.5} /> Design System
              </span>
              <span className='flex items-center gap-2 bg-primary-foreground/10 border border-primary-foreground/20 px-4 py-1.5 rounded-full text-xs text-primary-foreground/90'>
                <FileBarChart size={14} strokeWidth={1.5} /> All Components
              </span>
              <span className='flex items-center gap-2 bg-primary-foreground/10 border border-primary-foreground/20 px-4 py-1.5 rounded-full text-xs text-primary-foreground/90'>
                <Check size={14} strokeWidth={1.5} /> Live Theme
              </span>
            </div>
          </div>
        </div>

        <ShowcaseContent
          switchOn={switchOn}
          setSwitchOn={setSwitchOn}
          checkboxChecked={checkboxChecked}
          setCheckboxChecked={setCheckboxChecked}
          tabValue={tabValue}
          setTabValue={setTabValue}
          progressValue={progressValue}
          selectValue={selectValue}
          setSelectValue={setSelectValue}
          dateValue={dateValue}
          setDateValue={setDateValue}
          sidebarBrandName='Your Brand'
          footerLabel='Your Brand · Theme preview · All components use live theme variables'
        />
      </div>
    </TooltipProvider>
  );
};

export default BrandShowcaseWhitelabel;
